import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../_redux/student-absenteeism-report/StudentAbsenteeismReportAction";
import * as uiHelpers from "../StudentAbsenteeismReportUIHelpers";
import {
  getHandlerTableChange,
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useStudentAbsenteeismReportUIContext } from "../StudentAbsenteeismReportUIContext";

export function StudentAbsenteeismReportTable() {
  // Student Absenteeism Report UI Context
  const studentAbsenteeismReportUIContext = useStudentAbsenteeismReportUIContext();
  const studentAbsenteeismReportUIProps = useMemo(() => {
    return {
      queryParams: studentAbsenteeismReportUIContext.queryParams,
      setQueryParams: studentAbsenteeismReportUIContext.setQueryParams
    };
  }, [studentAbsenteeismReportUIContext]);

  // Getting curret state of Student Absenteeism Report list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.studentAbsenteeismReport }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;
  
  // Student Absenteeism Report Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getStudentAbsenteeismReport(studentAbsenteeismReportUIProps.queryParams));
    return () => dispatch(actions.cleanStudentAbsenteeismReportState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentAbsenteeismReportUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "section",
      text: "Şube",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "120px"
      }
    },
    {
      dataField: "studentNumber",
      text: "Öğrenci Numarası",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "180px",
      }
    },
    {
      dataField: "studentName",
      text: "Adı Soyadı",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "180px",
      }
    },
    {
      dataField: "parentName",
      text: "Veli Adı Soyadı",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "180px"
      }
    },
    {
      dataField: "absenteeismStatusName",
      text: "Durum",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "175px",
      }
    },
    {
      dataField: "date",
      text: "Tarih",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "120px",
      }
    },
    {
      dataField: "explanation",
      text: "Açıklama",
      sort: true,
      sortCaret: sortCaret,
      style: {
        minWidth: "225px",
      }
    },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: studentAbsenteeismReportUIProps.queryParams.pageSize,
    page: studentAbsenteeismReportUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                studentAbsenteeismReportUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}